export default __webpack_public_path__ + "static/horn_strobe_w.299ab2c21be294d0708e972324c2677a.svg";